"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMulticallProvider = void 0;
/**
 * Provider for fetching data on chain using multicall contracts.
 *
 * @export
 * @abstract
 * @class IMulticallProvider
 * @template TMulticallConfig
 */
class IMulticallProvider {
}
exports.IMulticallProvider = IMulticallProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXVsdGljYWxsLXByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9tdWx0aWNhbGwtcHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBb0RBOzs7Ozs7O0dBT0c7QUFDSCxNQUFzQixrQkFBa0I7Q0ErRHZDO0FBL0RELGdEQStEQyJ9